import { render, staticRenderFns } from "./SettingsPackingConfigView.vue?vue&type=template&id=9d9dfb28&"
import script from "./SettingsPackingConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsPackingConfigView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPackingConfigView.vue?vue&type=style&index=0&id=9d9dfb28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports